import { useCms, useContent } from '@eneco/cms';
import RichText from '@eneco/components/RichText/RichText';
import { Heading, Stack, Text } from '@eneco/sparky';

import type { FormFieldComponent } from './types';

interface ParagraphContent {
  paragraph?: { title?: string; content?: unknown };
}

/** Static copy inside a form. Contributes no validation, so it declares no `formSchema`. */
const GenericFormParagraph: FormFieldComponent = () => {
  const { adapter } = useCms();
  const { paragraph } = useContent<ParagraphContent>();
  const body = adapter.toRichText(paragraph?.content);

  if (!paragraph?.title && !body) return null;

  return (
    <Stack gap="3">
      {paragraph?.title && (
        <Heading as="h3" size="XS">
          {paragraph?.title}
        </Heading>
      )}
      {body && (
        <Text>
          <RichText html={body} />
        </Text>
      )}
    </Stack>
  );
};

export default GenericFormParagraph;
